import { render, staticRenderFns } from "./k-main.vue?vue&type=template&id=76922d7b&lang=pug&"
import script from "./k-main.vue?vue&type=script&lang=js&"
export * from "./k-main.vue?vue&type=script&lang=js&"
import style0 from "./k-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76922d7b')) {
      api.createRecord('76922d7b', component.options)
    } else {
      api.reload('76922d7b', component.options)
    }
    module.hot.accept("./k-main.vue?vue&type=template&id=76922d7b&lang=pug&", function () {
      api.rerender('76922d7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-main.vue"
export default component.exports